import {fork} from "redux-saga/effects";
import {watchChangeEventFilter} from "./sagas/eventFilterChangedSaga";
import {watchChangeResourceFilter} from "./sagas/changeResourceFilterSaga";


const calendarSagas = [
    fork(watchChangeEventFilter)
    , fork(watchChangeResourceFilter)
]

export default calendarSagas
